import React, { useState } from "react";
import Reach from "../../components/Common/Reach/Reach";
import HomeScreen from "../HomeScreen/HomeScreen";
import "../../components/Common/scss/main.scss";
import Features from "../../components/Common/Features/Features";
import FeaturesList from "../../components/Common/Features/FeaturesList";
import Institutes from "../../components/Common/Institutes/Institutes";
import Footer from "../../components/Common/Footer/Footer";
import Header from "../../components/Common/Header/Header";
import InstitutesList from "../../components/Common/Institutes/InstitutesList";
import Testimonial from "../../components/Common/Testimonial/Testimonial";

export const MobileScreen = () => {
  const [showRadarScreen, setShowRadarScreen] = useState(false);

  return (
    <>
      <Header />
      <HomeScreen
        showRadarScreen={showRadarScreen}
        setShowRadarScreen={setShowRadarScreen}
      />
      <Reach />
      <Features isMobile={true} />
      <FeaturesList />
      <Institutes />
      <Testimonial isMobile={true}/>
      <div className="institutes__content">
        <InstitutesList />
      </div>
      <Footer />
    </>
  );
};
